import React, { useState, forwardRef, useImperativeHandle, useRef, } from 'react';
import { Upload, CnButton, CnIcon } from '@alife/cn-ui';
import { getAppConfig } from 'src/utils/config';
import { preUrl, prodUrl } from 'src/utils/const';
import { imgPreview } from 'src/utils/dom';
import { previewImage, XReplyPlayer } from 'src/utils/xreplay';
import './index.scss';
import { nonstandardFileImgLink } from 'src/utils/const';
const isStandardFile = (type) => {
    return ['image/png', 'image/jpeg', 'video/xreplay'].some(it => type?.indexOf(it) > -1);
};
const CustomUpload = forwardRef(({ disableUpload = false, headers = {}, 
// accept = 'image/png, image/jpg',
multiple = false, fileData = {}, limit = 5, }, ref) => {
    const [fileValue, setFileValue] = useState([]);
    const [recordingId, setRecordingId] = useState('');
    const uploadRef = useRef(null);
    const uploadDomRef = useRef(null);
    // console.log('uploadRef', uploadRef);
    useImperativeHandle(ref, () => ({
        getValue: () => {
            return fileValue;
        },
        click() {
            uploadDomRef.current?.click?.();
        },
        selectFiles(files) {
            // @ts-ignore
            uploadRef?.current?._instance?.selectFiles?.(files);
        },
        appendFiles(files) {
            setFileValue([...fileValue, ...files]);
        },
    }));
    const beforeUpload = (file) => {
        // console.log(file)
    };
    const onSuccess = (file) => {
        let files = JSON.parse(JSON.stringify(fileValue));
        files.push({
            name: file.name,
            url: file.url,
            type: file.type,
            key: file?.response?.key,
            state: 'done',
        });
        setFileValue(files);
    };
    const onRemove = (file) => {
        const files = fileValue.filter((m) => m.key !== file.key);
        setFileValue(files);
    };
    const onPreview = (file, e) => {
        e?.preventDefault?.();
        // console.log('file', file, e);
        if (!isStandardFile(file.type))
            return;
        if (file.type.indexOf('image') > -1) {
            imgPreview([file.url]);
        }
        else if (file.type?.indexOf('xreplay') > -1) {
            setRecordingId(file.key);
        }
    };
    const actionRender = (file) => {
        if (!isStandardFile(file.type))
            return;
        let type = '';
        if (file.type.indexOf('image') > -1) {
            type = 'edit';
        }
        else if (file.type.indexOf('xreplay') > -1) {
            type = 'play-r';
        }
        return type ? React.createElement(CnButton, { text: true, className: 'cn-ui-intelli-assistant-feedback-upload-action-btn', onClick: e => {
                if (type === 'edit') {
                    previewImage(file.url, file.name).then(res => {
                        // console.log('res', file, res);
                        Object.assign(file, res);
                        setFileValue([...fileValue]);
                    });
                    return;
                }
                onPreview(file, e);
            }, size: "large" },
            React.createElement(CnIcon, { type: type, style: { marginRight: 12, cursor: "pointer" } })) : null;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Upload, { name: 'file', ref: uploadRef, action: `${getAppConfig()?.env === 'prod' ? prodUrl : preUrl}/file/uploadFile`, listType: 'image', className: "cn-ui-intelli-assistant-feedback-upload", disabled: disableUpload, data: fileData, headers: headers, 
            // accept={accept}
            multiple: multiple, limit: limit, onSuccess: onSuccess, beforeUpload: beforeUpload, value: fileValue, formatter: (response, file) => {
                // console.log('file', file);
                return {
                    status: true,
                    name: file.name,
                    url: isStandardFile(file.type) ? response?.data?.url : nonstandardFileImgLink,
                    key: response?.data?.key,
                    type: file.type,
                };
            }, onRemove: onRemove, previewOnFileName: true, 
            // @ts-ignore
            onPreview: onPreview, actionRender: actionRender },
            React.createElement("div", { ref: uploadDomRef, style: { width: 1, height: 1 } })),
        recordingId ? React.createElement(XReplyPlayer, { recordingId: recordingId, onClose: () => setRecordingId('') }) : null));
});
export default CustomUpload;
